export enum FloatingActionSize {
  SMALL = 'small',
  MID = 'mid',
}

export enum FloatingActionColor {
  PRIMARY = 'primary',
  DEFAULT = 'default',
}

export enum FloatingActionPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
}
